import { lazy } from 'react';

// Lazy load centre components to reduce initial bundle size
export const Colebee = lazy(() => import("@/pages/centres/Colebee"));
export const Penrith = lazy(() => import("@/pages/centres/Penrith"));
export const Riverstone = lazy(() => import("@/pages/centres/Riverstone"));
export const Truganina = lazy(() => import("@/pages/centres/Truganina"));
export const ThePonds = lazy(() => import("@/pages/centres/ThePonds"));
export const CarolineSprings = lazy(() => import("@/pages/centres/CarolineSprings"));
export const Tarneit = lazy(() => import("@/pages/centres/Tarneit"));
export const Clyde = lazy(() => import("@/pages/centres/Clyde"));
export const PointCook = lazy(() => import("@/pages/centres/PointCook"));
export const Werribee = lazy(() => import("@/pages/centres/Werribee"));
export const CanningVale = lazy(() => import("@/pages/centres/CanningVale"));